/** Ayudas de la página para firmar (9.12) y de «Mis documentos». */

/** «jueves 22 de octubre, 15:00» (la hora del navegador del cliente). */
export function plazo(iso: string): string {
    const f = new Date(iso);
    const dia = f.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
    const hora = f.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    return `${dia}, ${hora}`;
}

/** La dirección de vuelta: esta página con `?vuelta=1`, solo si es https (G475); si no, sin vuelta. */
export function direccionDeVuelta(href: string): string | null {
    try {
        const u = new URL(href);
        if (u.protocol !== 'https:') {
            return null;
        }
        u.search = '?vuelta=1';
        u.hash = '';
        return u.toString();
    } catch {
        return null;
    }
}
